module.exports = __webpack_public_path__ + "img/29.e393cd71.jpg";